import NumberListFormItem from 'components/Application/InitialApplication/NumberListFormItem';
import CustomButton from 'components/CustomInput/Button';
import TextHeader from 'components/CustomText/TextHeader';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { SHyperLink } from 'style/CommonStyledComponent';
import styled from 'styled-components/macro';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CustomTable from 'components/CustomTable';

const SLayout = styled.div`
    padding: 10px;
`;

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    td: {
        border: '1px solid #000',
        padding: '0 10px',
    },
    table: {
        borderCollapse: 'collapse',
        // color:
    },
    td2: {
        border: '1px solid #000',
    },
    topSubTd: {
        paddingTop: 5,
    },
    subTd: {
        borderTop: '1px solid #000',
        padding: '5px 5px 5px 5px',
        marginTop: 5,
    },
    tableTitle: {
        padding: 10,
    },
    '@global': {
        li: {
            padding: '5px 0',
        },
    },
}));

const SCustomTable = styled.table`
    border: 1px solid black;
    border-collapse: collapse;
    td {
        border: 1px solid black;
        border-collapse: collapse;
    }

    tr {
        border: 1px solid black;
        border-collapse: collapse;
    }

    th,
    td {
        padding: 15px 80px;
        text-align: center;
    }

    td a {
        color: blue;
        text-decoration: underline;
        cursor: pointer;
    }
`;

const STableLayout = styled.div`
    max-width: 1500px;
`;

const Help = ({ showManualOnly = false }) => {
    const history = useHistory();
    const classes = useStyles();

    return (
        <SLayout>
            {showManualOnly && (
                <div style={{ marginBottom: 20 }}>
                    <CustomButton
                        onClick={() => {
                            history.push('/');
                        }}
                    >
                        Back to Login
                    </CustomButton>
                </div>
            )}

            {!showManualOnly && (
                <>
                    <TextHeader underline>Checklist for AI / App-assisted Research</TextHeader>

                    <CustomTable
                        style={{ marginTop: 20 }}
                        fullWidthTable={false}
                        rows={[
                            {
                                id: '0',
                                subject: `Checklist for Artificial Intelligence / Mobile Application-assisted Research`,
                                irb: '/form/Central IRB Checklist for AI or Apps Research Projects_20260518.pdf',
                            },
                        ]}
                        columns={[
                            { field: 'subject', headerName: 'Subject', width: 420 },
                            {
                                field: 'irb',
                                headerName: 'Central IRB',
                                width: 200,
                                disableItemSort: true,
                                fixWidth: true,
                                valueGetter: (params) => {
                                    return (
                                        <a
                                            href={params.value}
                                            download
                                        >
                                            <SHyperLink>Attachment</SHyperLink>
                                        </a>
                                    );
                                },
                            },
                            {
                                field: 'hku',
                                headerName: 'HKU/HA HKW IRB',
                                width: 200,
                                disableItemSort: true,
                                fixWidth: true,
                                valueGetter: () => 'N/A',
                            },
                            {
                                field: 'ntec',
                                headerName: 'Joint CUHK-NTEC CREC',
                                width: 200,
                                disableItemSort: true,
                                fixWidth: true,
                                valueGetter: () => 'N/A',
                            },
                        ]}
                    />
                    
                    <TextHeader underline style={{ marginTop: 30 }}>Forms / Templates</TextHeader>

                    <CustomTable
                        style={{ marginTop: 20 }}
                        fullWidthTable={false}
                        rows={[
                            {
                                id: '0',
                                subject: `Investigator's Declaration of Conflict of Interest Form`,
                                irb: '/form/Investigators_conflict_of_interest form_1_Aug_24.docx',
                                hku: '/form/Investigators_conflict_of_interest form_1_Aug_24.docx',
                                ntec: '/form/Investigators_conflict_of_interest form_1_Aug_24.docx',
                            },
                        ]}
                        columns={[
                            { field: 'subject', headerName: 'Subject', width: 420 },
                            {
                                field: 'irb',
                                headerName: 'Central IRB',
                                width: 200,
                                disableItemSort: true,
                                fixWidth: true,

                                valueGetter: (params) => {
                                    return (
                                        <a
                                            //  href="/form/Declaration_of_Conflict_of_Interest_Investigators_v1.docx"
                                            href={params.value}
                                        >
                                            <SHyperLink>Attachment</SHyperLink>
                                        </a>
                                    );
                                },
                            },
                            {
                                field: 'hku',
                                headerName: 'HKU/HA HKW IRB',
                                width: 200,
                                disableItemSort: true,
                                fixWidth: true,
                                valueGetter: (params) => {
                                    return (
                                        <a
                                            //  href="/form/Declaration_of_Conflict_of_Interest_Investigators_v1.docx"
                                            href={params.value}
                                        >
                                            <SHyperLink>Attachment</SHyperLink>
                                        </a>
                                    );
                                },
                            },
                            {
                                field: 'ntec',
                                headerName: 'Joint CUHK-NTEC CREC',
                                width: 200,
                                fixWidth: true,
                                disableItemSort: true,
                                valueGetter: (params) => {
                                    return (
                                        <a
                                            //  href="/form/Declaration_of_Conflict_of_Interest_Investigators_v1.docx"
                                            href={params.value}
                                        >
                                            <SHyperLink>Attachment</SHyperLink>
                                        </a>
                                    );
                                },
                            },
                        ]}
                    />

                    {/* <ul>
                        <SListItem>
                            <a href="/form/Declaration_of_Conflict_of_Interest_Investigators_v1.docx">
                                <SHyperLink>For Central IRB</SHyperLink>
                            </a>
                        </SListItem>
                        <SListItem>
                            <a href="/form/d_conflict_of_interest.docx">
                                <SHyperLink>For HKU/HA HKW IRB</SHyperLink>
                            </a>
                        </SListItem>

                        <SListItem>
                            <a href="/form/Investigators_conflict_of_interest form_12_March_14.doc">
                                <SHyperLink>For Joint CUHK-NTEC CREC</SHyperLink>
                            </a>
                        </SListItem>
                    </ul> */}
                </>
            )}

            <STableLayout>
                <TextHeader style={{ marginTop: 30 }} underline>Central IRB – Routine Panel</TextHeader>
                <SCustomTable style={{ marginTop: 20, width: '100%' }}>
                    <tbody>
                        <tr>
                            <td>
                                <a href="/form/Central IRB SOP_2024-2027.pdf" download>
                                    Central IRB Standard Operating Procedure
                                </a>
                            </td>
                            <td>
                                <a href="/form/Central-IRB-Submission-Guide-(Initial-Application)-250401.pdf" download>
                                    Submission Guide (Initial Application)
                                </a>
                            </td>
                            <td>
                                <a href="/form/Central-IRB-Submission-Guide-(Post-approval)-250401.docx" download>
                                    Submission Guide (Post-approval Activities)
                                </a>
                            </td>
                            <td>
                                <a href="/form/Draft Template_Research Protocol_Feb 2020.doc" download>
                                    Research Protocol
                                </a>
                            </td>
                            <td>
                                <a href="/form/Routine Panel Full Review Meeting Schedule 2026.pdf" download>
                                    Central IRB Routine Panel Full Review Meeting Schedule
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="/form/Template of Data Collection Form.xls" download>
                                    Data Collection Form
                                </a>
                            </td>
                            <td>
                                <a href="/form/Draft Template_Information Sheet_Jun 2024.doc" download>
                                    Information Sheet (English & Chinese versions)
                                </a>
                            </td>
                            <td>
                                <a href="/form/Draft Template_Consent Form_Feb 2020.doc" download>
                                    Informed Consent Form (English & Chinese versions)
                                </a>
                            </td>
                            <td>
                                <a href="/form/Draft Template_Information Sheet and Informed Consent Form_Case Report Study_Jun2024.docx" download>
                                    Information Sheet and Informed Consent Form<br />(For Case Report Study)
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </SCustomTable>

                <TextHeader style={{ marginTop: 30 }} underline>Central IRB – PAED Panel</TextHeader>
                <SCustomTable style={{ marginTop: 20 }}>
                    <tbody>
                        <tr>
                            <td>
                                <a href="/form/(Confirmed) Central IRB - PAED Panel Submission Guide (Initial Application).20250415.pdf" download>
                                    Submission Guide
                                </a>
                            </td>
                            <td>
                                <a href="/form/HKCH_Protocol_Checklist.pdf" download>
                                    Research Protocol Checklist
                                </a>
                            </td>
                            <td>
                                <a href="/form/HKCH_Information Sheet and Informed Consent Form_Checklist.pdf" download>
                                    Information Sheet and Informed Consent Form Checklist
                                </a>
                            </td>
                            <td>
                                <a href="/form/HKCH_Information Sheet and Informed Consent Form_Sample.docx" download>
                                    Information Sheet and Informed Consent Form
                                </a>
                            </td>
                            <td>
                                <a href="/form/Paed Panel Full Review Meeting Schedule 2026.pdf" download>
                                    Central IRB – Paed Panel Full Review Meeting Schedule
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="/form/HKCH_Information Sheet and Informed Consent Form_Case Report Study_Sample.docx" download>
                                    Information Sheet and Informed Consent Form (For Case Report Study)
                                </a>
                            </td>
                            <td>
                                <a href="/form/HKCH_Information Sheet_Material and Assent Form_Checklist.pdf" download>
                                    Information Sheet / Material and Assent Form Checklist 
                                </a>
                            </td>
                            <td>
                                <a href="/form/HKCH_Assent Form_Sample.docx" download>
                                    Assent Form
                                </a>
                            </td>
                            <td>
                                <a href="/form/Operational Readiness Form for Clinical Research in HKCH.docx" download>
                                    Operational Readiness Form - (For HKCH staff only)
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </SCustomTable>
            </STableLayout>

            <TextHeader style={{ marginTop: 30 }} underline>
                Institutional Review Board of the University of Hong Kong / Hospital Authority Hong Kong West Cluster (HKU/HA HKW IRB)
            </TextHeader>
            <Typography style={{ marginTop: 10 }}>
                <a href="https://www.med.hku.hk/en/research/ethics-and-integrity/human-ethics" target="_blank" rel="noopener noreferrer">
                    Link to the HKU/HA HKW IRB
                </a>
            </Typography>

            <TextHeader style={{ marginTop: 30 }} underline>
                The Joint Chinese University of Hong Kong – New Territories East Cluster Clinical REC
            </TextHeader>
            <Typography style={{ marginTop: 10 }}>
                <a href="https://www.crec.cuhk.edu.hk/" target="_blank" rel="noopener noreferrer">
                    Link to the Joint CUHK-NTEC CREC
                </a>
            </Typography>

            <TextHeader style={{ marginTop: 30 }} underline>
                User Manual
            </TextHeader>

            <SCustomTable style={{ marginTop: 20 }}>
                <tbody>
                    <tr>
                        <td>
                            <a href="/form/CRER_User_Manual_for_Applicant_v2.5.pdf" download>
                                For Applicant
                            </a>
                        </td>
                        <td>
                            <a href="/form/CRER_User_Manual_for_Reviewer_v1.2.pdf" download>
                                For Reviewer
                            </a>
                        </td>
                        <td>
                            <a href="/form/CRER_User_Manual_for_Cluster_Admin_v2.1.pdf" download>
                                For Cluster Admin
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <a href="/form/CRER_User_Manual_for_Secretary_v2.3.pdf" download>
                                For Secretary
                            </a>
                        </td>
                        <td>
                            <a href="/form/CRER_User_Manual_for_CCO_v2.1.pdf" download>
                                For CCO
                            </a>
                        </td>
                        <td>
                            <a href="/form/CRER_User_Manual_for_Central_IRB_v2.5.pdf" download>
                                For Central IRB
                            </a>
                        </td>
                    </tr>
                </tbody>
            </SCustomTable>

            {/* <CustomTable
                columns={[
                    // { field: 'date', headerName: 'Release Date', width: 200 },
                    {
                        field: 'document',
                        headerName: 'Document',
                        width: 500,
                        valueGetter: (params) => {
                            return <SHyperLink>{params.value}</SHyperLink>;
                        },
                    },
                ]}
                rows={[
                    {
                        date: '28-03-2022',
                        document: 'User Manual - For Applicant',
                    },
                    {
                        date: '28-03-2022',
                        document: 'User Manual - For Reviewer',
                    },
                    {
                        date: '28-03-2022',
                        document: 'User Manual - For Secretary',
                    },
                    {
                        date: '28-03-2022',
                        document: 'User Manual - For CCO Secretary',
                    },
                    {
                        date: '28-03-2022',
                        document: 'User Manual - Client Machine Configuration Instruction',
                    },
                ]}
            /> */}

            {!showManualOnly && (
                <>
                    <TextHeader underline style={{ margin: '30px 0 10px 0' }}>
                        FAQ
                    </TextHeader>

                    <div className={classes.root}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography className={classes.heading}>
                                    <NumberListFormItem number={'1'} alignItems={'flex-start'}>
                                        What are the differences between Coordinating Investigator(CI) and Site
                                        Principal Investigator (Site PI)?
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <NumberListFormItem number={'A'} alignItems={'flex-start'}>
                                    <div style={{ fontWeight: 100 }}>
                                        <table className={classes.table}>
                                            <tbody>
                                                <tr>
                                                    <td className={classes.td}>Coordinating Investigator:</td>
                                                    <td className={classes.td}>
                                                        <ul>
                                                            <li>
                                                                To complete the 'Study Info' of the Application Form and
                                                                provide study-based application documents.
                                                            </li>
                                                            <li>
                                                                To coordinate with Site PIs to submit the Initial
                                                                Application for review.
                                                            </li>
                                                            <li>
                                                                To submit study-based Post-approval Applications (e.g.
                                                                Final Report, SUSAR Report, Study-based Amendment,
                                                                CTC/CTI etc.).
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className={classes.td}>Site Principal Investigator:</td>
                                                    <td className={classes.td}>
                                                        <ul>
                                                            <li>
                                                                To take responsibility for the conduct of study at
                                                                his/her study site.
                                                            </li>
                                                            <li>
                                                                To fill in 'Site Info' of the Application Form and to
                                                                provide site-specific application documents (e.g. CV,
                                                                declaration form etc.) and relevant signature pages.
                                                            </li>
                                                            <li>
                                                                To submit site-specific Post-approval Applications (e.g.
                                                                Progress Report, Local SAE Report, Protocol Deviation /
                                                                Compliance Incident Report, Site-specific Amendment
                                                                etc.).
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </NumberListFormItem>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3a-content"
                                id="panel3a-header"
                            >
                                <Typography className={classes.heading}>
                                    <NumberListFormItem number={'2'} alignItems={'flex-start'}>
                                        I will be the only investigator of this single-site application. Do I need to
                                        have a Coordinating Investigator in order to submit the application?
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <NumberListFormItem number={'A'} alignItems={'flex-start'}>
                                        <div style={{ fontWeight: 100 }}>
                                            Coordinating Investigator and Site PI are mandatory in every application. As
                                            you are the only investigator, you will be the CI and Site PI
                                            simultaneously. The Application Form is designed for both single- and
                                            multi-site applications. CI to complete “Study Info” (study-related
                                            question) while Site PI to complete “Site Info” (site-specific details).
                                            Hence, please fill in both tabs of application form in order to proceed the
                                            application.
                                        </div>
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography className={classes.heading}>
                                    <NumberListFormItem number={'3'} alignItems={'flex-start'}>
                                        I am planning to submit a multi-cluster application involving all HA clusters. I
                                        understand that HKWC and NTEC have a Joint HA-University IRB/REC. Can Central
                                        IRB grant ethics approval to all HA sites? Do I need to submit separate
                                        application to these 2 Joint HA-University IRB/REC?
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <NumberListFormItem number={'A'} alignItems={'flex-start'}>
                                        <div style={{ fontWeight: 100 }}>
                                            The review decision of Central IRB will be applicable to all HA hospitals
                                            (i.e. including QMH and PWH, and HA sites under HKIC(W) and NTEC). On the other
                                            hand, standalone application to HKU/HA HKW IRB and Joint CUHK-NTEC CREC is
                                            required as the Universities would like to maintain their own jurisdiction
                                            to oversee research ethics review related to their teaching hospitals.
                                            Please approach HKU/HA HKW IRB and Joint CUHK-NTEC CREC for submission details.
                                        </div>
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography className={classes.heading}>
                                    <NumberListFormItem number={'4'} alignItems={'flex-start'}>
                                        I am planning to submit a single-cluster application. Which IRB/REC should be selected for submission?
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <NumberListFormItem number={'A'} alignItems={'flex-start'}>
                                        <div style={{ fontWeight: 100 }}>
                                            With effect from 16 May 2022, all new applications must be submitted via the
                                            New Portal. Applications can only be submitted to 1) Central Institutional
                                            Review Board (Central IRB), 2) HKU/HA HKW IRB or 3) Joint CUHK-NTEC CREC, 
                                            depending on respective jurisdictions according to the primary affiliation 
                                            of the Coordinating Investigator. Applicant should refer to and follow the 
                                            submission deadline set by respective IRB/REC.
                                        </div>
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography className={classes.heading}>
                                    <NumberListFormItem number={'5'} alignItems={'flex-start'}>
                                        3 sets of reference number are seen in the Application List. What are the
                                        differences?
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <NumberListFormItem number={'A'} alignItems={'flex-start'}>
                                        <div style={{ fontWeight: 100 }}>
                                            These 3 reference numbers are generated in different stage:
                                        </div>
                                    </NumberListFormItem>
                                    <div style={{ fontWeight: 100, marginTop: 10 }}>
                                        <table className={classes.table}>
                                            <tbody>
                                                <tr>
                                                    <td className={classes.td}>Submission No.</td>
                                                    <td className={classes.td}>
                                                        <ul>
                                                            <li>when a draft application is created.</li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className={classes.td}>CRER Application No.</td>
                                                    <td className={classes.td}>
                                                        <ul>
                                                            <li>when the draft application is submitted.</li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className={classes.td}>IRB/REC Reference No.</td>
                                                    <td className={classes.td}>
                                                        <ul>
                                                            <li>
                                                                when IRB/REC confirmed and assigned an unique reference
                                                                number.
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{ fontWeight: 100, marginTop: 10 }}>
                                        Please ensure to provide the correct and corresponding reference number when
                                        communicating with the Secretariats.
                                    </div>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography className={classes.heading}>
                                    <NumberListFormItem number={'6'} alignItems={'flex-start'}>
                                        Will my department head receive notification to proceed the endorsement of my
                                        application?
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <NumberListFormItem number={'A'} alignItems={'flex-start'}>
                                        <div style={{ fontWeight: 100 }}>
                                            This function is not available in this Portal and e-signature is currently
                                            not accepted. To seek your department head support, please print the form in
                                            hard copy for wet-inked signature. For subsequent actions, e.g. to scan the
                                            form to Portal or to submit true copy, please contact respective IRB/REC for
                                            details.
                                        </div>
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography className={classes.heading}>
                                    <NumberListFormItem number={'7'} alignItems={'flex-start'}>
                                        Which IRB/REC is reviewing my application?
                                    </NumberListFormItem>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    {/* <NumberListFormItem number={'A'} alignItems={'flex-start'}>
                                        <div style={{ fontWeight: 100 }}>
                                            Jurisdiction of HKU/HA HKW IRB & Joint CUHK-NTEC CREC remain unchanged.
                                        </div>
                                        <div style={{ fontWeight: 100 }}>
                                            For applying site(s) in HKEC, KCC, KEC, KWC and NTWC:
                                        </div>
                                    </NumberListFormItem> */}
                                    <div style={{ fontWeight: 100, textAlign: 'center', marginTop: 10 }}>
                                        <table className={classes.table}>
                                            <tbody>
                                                <tr>
                                                    <td className={classes.td}>
                                                        <div className={classes.tableTitle}>Applying site(s) in HA</div>
                                                    </td>
                                                    <td className={classes.td}>
                                                        <div className={classes.tableTitle}>
                                                            To be reviewed by
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className={classes.td}>
                                                        <div>HKIC(E), KCC, KEC, KWC and NTWC</div>
                                                    </td>
                                                    <td className={classes.td}>
                                                        <div>Central IRB</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className={classes.td}>
                                                        <div>HKIC(W)</div>
                                                    </td>
                                                    <td className={classes.td}>
                                                        <div>HKU/HA HKW IRB</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className={classes.td}>
                                                        <div>NTEC</div>
                                                    </td>
                                                    <td className={classes.td}>
                                                        <div>Joint CUHK-NTEC CREC</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className={classes.td}>
                                                        <div>Multi-cluster study involving sites under jurisdiction of different IRB/REC</div>
                                                    </td>
                                                    <td className={classes.td}>
                                                        <div>According to Primary Affiliation of Coordinating Investigator</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </>
            )}
        </SLayout>
    );
};

export default Help;
